import { useSelector } from 'react-redux';
import { CustomSnackbar, CustomAlert } from './styled';

const Snackbar = (props) => {
  const { message, severity } = useSelector((state) => state.Toast);
  const {
    alertOpen,
    handleClose,
    vertical = 'bottom',
    horizontal = 'center',
    CustomeMessage,
    customeseverity,
    autoHideDuration = 2000,
  } = props;

  return !!message ? (
    <CustomSnackbar
      anchorOrigin={{ vertical, horizontal }}
      open={alertOpen}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
    >
      <CustomAlert
        onClose={handleClose}
        severity={severity}
        sx={{ width: '100%' }}
      >
        {message}
      </CustomAlert>
    </CustomSnackbar>
  ) : !!CustomeMessage ? (
    <CustomSnackbar
      anchorOrigin={{ vertical, horizontal }}
      open={alertOpen}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
    >
      <CustomAlert
        onClose={handleClose}
        customeseverity={customeseverity}
        sx={{ width: '100%' }}
      >
        {CustomeMessage}
      </CustomAlert>
    </CustomSnackbar>
  ) : (
    ''
  );
};

export default Snackbar;
